var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResearchIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.061,
    height: 99.434,
    viewBox: "0 0 68.061 99.434",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Research_Icon_2_REV",
    "data-name": "Research_Icon_2 REV",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13472",
    "data-name": "Path 13472",
    d: "M28.13,35.608a1.068,1.068,0,0,0,.646.212,1.068,1.068,0,0,0,.646-1.915l-5.078-3.842a1.065,1.065,0,1,0-1.292,1.693L28.13,35.6Z",
    transform: "translate(-1.713 17.829)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13473",
    "data-name": "Path 13473",
    d: "M77.919,106.556H58.049V99.01c13.937-1.2,24.931-13.308,24.931-28.082a28.419,28.419,0,0,0-12.266-23.54,8.364,8.364,0,0,0,.353-2.32,8.261,8.261,0,0,0-1.954-5.323l8.263-11.306a4.877,4.877,0,0,0-.871-6.618L74.458,20.21l3.3-4.493L72.787,11.81l-3.3,4.493-2.048-1.612a4.478,4.478,0,0,0-6.38.9L37.332,48.048a4.877,4.877,0,0,0,.871,6.618l9.064,7.106a4.478,4.478,0,0,0,6.38-.9l6.168-8.425a7.454,7.454,0,0,0,8.428-1.172A23.759,23.759,0,0,1,78.461,70.9c0,12.966-10.17,23.54-22.695,23.54A22.514,22.514,0,0,1,36.391,83.162H51.128a2.566,2.566,0,0,0,0-5.128H17.392a2.566,2.566,0,0,0,0,5.128H31.329A27.1,27.1,0,0,0,53.553,99.01v7.545H34.272a2.346,2.346,0,0,0,0,4.688H77.919a2.346,2.346,0,0,0,0-4.688Z",
    transform: "translate(-14.92 -11.81)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearchIcon2);
export default __webpack_public_path__ + "static/media/Research_Icon_2.143a25ed068ea2ff915cb8b5c11a8183.svg";
export { ForwardRef as ReactComponent };